module.exports = __webpack_public_path__ + "img/role21.43e5affa.png";